// extracted by mini-css-extract-plugin
export default {"mobile-grid-scale":".5","mouse-base-width":"74px","mouse-base-height":"84px","mouse-offset-top":"6px","mouse-offset-left":"4px"};